import TemplateContent from '../model/schemas/TemplateContent';
import _ from 'lodash';

export const templateRegExp = (): RegExp => /%{2}\d+/gm;

export const getTemplateText = (content: TemplateContent): string =>
  _.replace(content.template, templateRegExp(), key => {
    const groupKey = getGroupKey(key);
    const value =
      groupKey !== null && content.groups ? content.groups[groupKey] : null;
    if (value) {
      return value.text && value.text.length > 0
        ? value.rteText
          ? value.rteText
          : value.text
        : value.placeholder;
    } else {
      return '???';
    }
  });

export const getTemplateTextIfNotRatingPlaceholder = (
  content: TemplateContent
): string | null =>
  _.filter(content.groups, g => g.text === null || g.text === '').length === 0
    ? getTemplateText(content)
    : null;

export const getGroupKey = (key: string): number | null =>
  templateRegExp().test(key) ? parseInt(key.slice(2)) : null;

export const isTemplateEditable = (content: TemplateContent): boolean =>
  !!content.groups && Object.keys(content.groups).length > 0;

export const isTemplateFilled = (content: TemplateContent): boolean =>
  content.template.length > 0 &&
  (!content.groups ||
    _.filter(content.groups, g => g.text === null).length === 0);
